{
    "notifications": {
        "Bildirimler": "Meldingen",
        "Ara...": "Zoeken...",
        "Hata oluştu": "Er is een fout opgetreden",
        "Admin": "Admin",
        "Tümünü Okunmadı Olarak İşaretle": "Markeer alles als ongelezen",
        "Tümünü Okundu Olarak İşaretle": "Markeer alles als gelezen",
        "Bildirim Bulunamadı!": "Geen meldingen gevonden!",
        "Tüm Bildirimleri Gör": "Bekijk alle meldingen",
        "Tüm Bildirimler": "Alle meldingen",
        "Hiç bildiriminiz yok": "Je hebt geen meldingen.",
        "Bildirim Gönder": "Melding Verzenden",
        "Yönlendirilecek URL (Opsiyonel)": "Omleidings-URL (Optioneel)",
        "Mesaj": "Bericht",
        "Hedef Kitle": "Doelgroep",
        "Herkese Gönder": "Naar Iedereen Verzenden",
        "Belirli Kullanıcılara Gönder": "Naar Geselecteerde Gebruikers Verzenden",
        "Kullanıcı Seçiniz": "Selecteer Gebruiker",
        "Başlık": "Titel",
        "Gönder": "Verzenden",
        "Okundu Olarak İşaretle": "Markeer als gelezen",
        "Sil": "Verwijderen",
        "Validation": {
            "required": "Verplicht veld"
        },
        "success": "Melding succesvol verzonden.",
        "Bildirim Ayarları": "Meldingeninstellingen",
        "Tarayıcınız bildirimleri desteklemiyor": "Uw browser ondersteunt geen meldingen.",
        "Bildirim izni reddedildi Tarayıcı ayarlarından izin verin": "Meldingsrechten geweigerd. Sta toe in browserinstellingen.",
        "Kayıtlı Cihazlar": "Geregistreerde Apparaten",
        "Yenile": "Vernieuwen",
        "Cihaz Bilgisi": "Apparaatinformatie",
        "Kayıt Tarihi": "Registratiedatum",
        "Son Erişim": "Laatste Toegang",
        "İşlem": "Actie",
        "Bilinmeyen Cihaz": "Onbekend Apparaat",
        "Bu Cihaz": "Dit Apparaat",
        "Kayıtlı cihaz bulunamadı": "Geen geregistreerde apparaten gevonden.",
        "Ayarlar": "Instellingen",
        "Cihaz listesi alınamadı": "Kan apparaatlijst niet ophalen.",
        "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz": "Weet u zeker dat u het abonnement van dit apparaat wilt verwijderen?",
        "Cihaz silindi": "Apparaat verwijderd.",
        "Cihaz silinemedi": "Kan apparaat niet verwijderen.",
        "Bildirimleri Kapat": "Meldingen Uitschakelen",
        "Bildirimleri Aç": "Meldingen Inschakelen",
        "Bildirim İzinleri": "Meldingstoestemmingen",
        "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz": "U kunt hier beheren of u meldingen van dit apparaat wilt ontvangen."
    }
}
